import React from "react"
import { Modal, DatePicker } from "antd"
import DatePickerIcon from "components/Icons/DatePicker"

interface RangePickerModalProps {
  isOpen: boolean
  timeFormat: any
  onCancel: () => void
  onChange: (dates: any) => void
}

const RangePickerModal: React.FC<RangePickerModalProps> = ({
  isOpen,
  timeFormat,
  onCancel,
  onChange
}) => {
  const { RangePicker } = DatePicker

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      width={500}
      footer={null}
      maskClosable={false}
      wrapClassName="ant-modal-middle-space ant-modal-range-picker"
    >
      <RangePicker
        // showTime
        // format={`YYYY-MM-DD HH:mm ${timeFormat === "12" ? "A" : ""}`}
        showTime={{
          use12Hours: timeFormat === "12",
          format: `YYYY-MM-DD ${timeFormat === "12" ? "h:mm a" : "HH:mm"}`
        }}
        format={`YYYY-MM-DD ${timeFormat === "12" ? "h:mm a" : "HH:mm"}`}
        value={null}
        onChange={onChange}
        className="w-100"
        suffixIcon={<DatePickerIcon />}
      />
    </Modal>
  )
}

export default RangePickerModal